<template>
  <div class="prodetailApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">

    <div class="card">
      <ul>
        <li>
          <h3>{{proDetail.title}}</h3>
          <div class="price"><font>使用时间：</font>{{proDetail.starttime}} 至 {{proDetail.endtime}}</div>
          <div class="rate"><font>市场价：</font><span style="text-decoration: line-through">￥{{proDetail.price}}</span></div>
          <div class="price"><font>优惠价：</font>
            <i>￥</i><b>{{proDetail.rate.split(".")[0]}}</b>
            <i>.{{proDetail.rate.split(".")[1]}}</i>
          </div>
        </li>
      </ul>

      <div class="chooseUser" v-if="attest.length <= 0" @click="go">
        <div class="leftuser">
          <p>选择人员</p>
        </div>
        <img src="~assets/images/me_jiantou.png" />
      </div>
      <div class="chooseUser" v-if="attest.length > 0">
        <div class="leftuser" @click="drawer = true">
          <p>{{name}}</p>
          <p class="curt" v-if="idCard !=''">{{idCard}}</p>
        </div>
        <img src="~assets/images/me_jiantou.png" />
      </div>

      <h2>入园说明</h2>
      <ul>
        <li>
          <span style="padding:10px 15px;font-size:16px;line-height:24px;display:block;text-align: justify;">购买公园卡后，请到对应景区联系工作人员并告知是“南宁公园卡用户”，然后扫景区二维码抵扣入园次数后入园。</span>
        </li>
      </ul>
      <h2>包含门票</h2>
      <dl>
        <dd class="curt">
          <span>景点名称</span>
          <font>数量</font>
        </dd>
        <dd v-for="(item,i) in card">
          <span>{{item.title}}</span>
          <font>{{item.num}}</font>
        </dd>
      </dl>
    </div>
    <div style="height:52px"></div>
    <div class="footer1">
      <div class="foot-title">
        <span>合计：<i>￥</i><b>{{proDetail.rate.split(".")[0]}}</b>
          <i>.{{proDetail.rate.split(".")[1]}}</i>
        </span>
        <span>1件商品</span>
      </div>
      <div class="pay" @click="payment">
        <span>立即购买</span>        
      </div>
    </div>


    <el-drawer
      title="选择人员" :visible.sync="drawer" :direction="direction" size="50%" :withHeader="true">
      <ul>
        <li v-for="(item,i) in attest" @click="choose(i)">
          <p>{{item.name}}</p>
          <p>{{item.card}}</p>
          <a v-if="i==active"><img src="~assets/images/choose2.png" /></a>
          <a v-if="i!=active"><img src="~assets/images/choose1.png" /></a>
        </li>
      </ul>
      <a class="append" @click="go">追加人员</a>
    </el-drawer>

  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        proDetail:[],
        card:[],
        userData:[],
        phone:'',
        name:'选择人员',  
        idCard:'', 
        drawer:false,
        direction: 'btt',
        attest:[],
        code:'',
        codes:'',
        active:-1,
        special1:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('special1') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id;
          var url = encodeURIComponent('http://user.4008005216.com/main/specialPay?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx4dffc66bfc2862b0&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.codes = code;
          this.login();
        }
      }else{
        this.special1 = localStorage.getItem('special1') == null ? [] : localStorage.getItem('special1');
      }
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
    },
    mounted() {

      this.beforeMount();
      this.getDetail();
      this.attest1();
      
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      go:function(){
        window.location.href="http://user.4008005216.com/main/attest"
      },

      choose:function(n){
        this.active = n;
        this.idCard = this.attest[n].card;
        this.name = this.attest[n].name;
        this.drawer = false;
      },

      attest1:function(){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/user/attest',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.attest = res.rs;
          that.phone = res.phone.phone;
          that.fullscreenLoading = false;
        }).catch(err=>{
          that.fullscreenLoading = false
        });
      },

      payment:function(){
        var that = this;
        if(that.name == '选择人员'){
          alert('请选择购票人员！');
          return false;
        }
        if(that.phone == ''){
          alert('请输入手机号！');
          return false;
        }
        var id = this.$route.query.id;

        that.axios({
          method:'post',
          url:that.$host+'home/special/weixinPay',
          params:{
            id:id,
            user_id:that.userData.id,
            phone:that.phone,
            code:that.code,
            name:that.name,
            idCard:that.idCard,
            pay_money:that.proDetail.rate,
            openid:that.special1
          }
        }).then(function(response){
          var res = response.data.data;
          if(response.data.status == 200){
            that.callpay(res);
          }else{
            alert('验证码无效');
          }
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      jsApiCall:function(msg){
        var that = this;
          WeixinJSBridge.invoke(
              'getBrandWCPayRequest',
              {
                "appId":'wx4dffc66bfc2862b0',
                "timeStamp":msg.timeStamp,         //时间戳，自1970年以来的秒数     
                "nonceStr":msg.nonceStr, //随机串     
                "package":msg.package,     
                "signType":msg.signType,         //微信签名方式：     
                "paySign":msg.paySign 
              },
              function(res){
                  if(res.err_msg == "get_brand_wcpay_request:ok"){
                    window.location.href="http://user.4008005216.com/main/scenicOrder?id=2";
                  }else{
                     //返回跳转到订单详情页面
                      alert('支付失败');return false
                  }
              }
          );
      },

      callpay:function(data){
        if (typeof WeixinJSBridge == "undefined"){
          if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
          }else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', jsApiCall); 
              document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
          }
        }else{
          this.jsApiCall(data);
        }
      },
      getDetail:function(){
        var id = this.$route.query.id;
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/order/payOrder',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;

          that.proDetail = res.rs;
          that.card = res.card;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/special/login',
          params:{
            code:that.codes
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('special1', res.data);
          that.special1 = res.data
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .prodetailApp{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
    padding-top:15px;
  }

  .prodetailApp .card ul{
    width:94%;
    display:block;
    margin:0 auto;
    background:#fff;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    margin-bottom:15px;
  }
  .prodetailApp .card ul li{
    width:100%;
    position:relative;
  }
  .prodetailApp .card ul li h3{
    font-size:16px;
    padding:15px 15px 10px 15px;
    width:75%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing:1.5px
  }


  .prodetailApp .card ul li .price{
    font-size:15px;
    padding:0 15px 10px 15px;
    color:#999
  }
  .prodetailApp .card ul li .rate{
    font-size:15px;
    padding:0 15px 10px 15px;
    color:#999
  }
  .prodetailApp .card ul li .price font{
    color:#999;
    font-size:15px;
  }
  .prodetailApp .card ul li .price b{
    color: #FF6600;
    font-size:17px;
    font-weight:500;
  }

  .prodetailApp .card ul li .price i{
    color: #FF6600;
    font-size:12px;
    font-style:normal
  }


  .prodetailApp .chooseUser{
    width:94%;
    display:block;
    margin:0 auto;
    background:#fff;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    padding:20px 0;
    position:relative;
  }
  .prodetailApp .chooseUser:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .prodetailApp .chooseUser .leftuser{
    float:left;
    width:80%;
    margin-left:15px;
  }
  .prodetailApp .chooseUser .leftuser p{
    color:#333;
    font-size:15px;
  }
  .prodetailApp .chooseUser .leftuser p.curt{
    padding-top:10px;
    color:#666
  }
  .prodetailApp .chooseUser img{
    width:8px;
    position:absolute;
    top:51%;
    transform: translateY(-50%);
    right:15px;
  }

  
  
  .prodetailApp .card h2{
    font-size:16px;
    font-weight:bold;
    padding:15px 0px 10px 0px;
    height:40px;
    line-height:40px;
    letter-spacing:1px;
    width:94%;
    margin:0 auto;

  } 
  .prodetailApp .card dl{
    display:block;
    width:94%;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    margin:0 auto
  }
  .prodetailApp .card dl dd{
    height:50px;
    line-height:50px;
    border-bottom:solid 1px #EBF2FF;
    width:92%;
    margin:0 auto;
  }
  .prodetailApp .card dl dd span{
    float:left;
    width:80%;
    height:50px;
    line-height:50px;
    font-size:15px;
    letter-spacing:1px;
    color:#333;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .prodetailApp .card dl dd.curt span{
    color:#666
  }

  .prodetailApp .card dl dd font{
    float:right;
    height:50px;
    line-height:50px;
    color:#2F78FF;
    font-size:15px;
    margin-right:5px;
  }
  .prodetailApp .card dl dd.curt font{
    color:#666
  }

  .footer1{
    height: 50px;
    background: #fff;
    width: 94%;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    position: fixed;
    bottom: 10px;
    left: 3%;
    z-index: 1
  }
  .prodetailApp .footer1 .foot-title{
    float: left;
    margin-left: 4%;
    height:50px;
    line-height:50px;
  }
  .prodetailApp .footer1 .foot-title span{
    font-size: 14px;
    color: #727272;
  }
  .prodetailApp .footer1 .foot-title span:first-child{
    margin-right:8px
  }
  .prodetailApp .footer1 .foot-title span b{
    color: #FF6600;
    font-size:17px;
    font-weight:500;
  }

  .prodetailApp .footer1 .foot-title span i{
    color: #FF6600;
    font-size:12px;
    font-style:normal
  }

  .prodetailApp .footer1 .pay{
    float: right;
    color: #fff;
    margin-right: 4%;
    margin-top:5px;
    width:40%
  }
  .prodetailApp .footer1 .pay span{
    float:left;
    height:40px;
    line-height:40px;
    font-size: 14px;
    width:100%;
    text-align:center;
    font-weight:bold;
    background: #FF751A;
    border-radius:40px;
  }
  .prodetailApp #el-drawer__title span{
    text-align:center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #2F78FF;
  }

  .prodetailApp .el-drawer__wrapper ul{
    width:90%;
    margin:0 auto;
  }
  .prodetailApp .el-drawer__wrapper li{
    border-bottom:solid 1px #EBF2FF;
    padding:15px 0 10px 0;
    position:relative;
  }
  .prodetailApp .el-drawer__wrapper li:last-child{
    border-bottom:none;
  }

  .prodetailApp .el-drawer__wrapper li p{
    padding-bottom:10px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    padding-left:45px;
  }
  .prodetailApp .el-drawer__wrapper li p:last-child{
    color: #666;
  }

  .prodetailApp .el-drawer__wrapper li a{
    position:absolute;
    left:0;
    top:50%;
    transform: translateY(-50%);
    color: #2F78FF;
    font-size:18px;
  }
  .prodetailApp .el-drawer__wrapper li a img{
    display:block;
    width:30px;
  }

  .prodetailApp .el-drawer__wrapper .append{
    background:#2F78FF;
    color:#fff;
    position:absolute;
    right:20px;
    top:25%;
    font-size:14px;
    padding:5px 10px;
    border-radius: 10px
  }
 
</style>